import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Clock, ArrowRight } from "lucide-react";

// Blog posts data
const blogPosts = [
  {
    id: 1,
    slug: "fiduciaire-vs-comptable-interne-pme-suisse",
    title: "Fiduciaire ou comptable interne : que choisir pour votre PME suisse ?",
    excerpt: "Le comparatif honnête que votre expert-comptable ne vous fera pas. Analyse chiffrée des coûts, avantages et limites de chaque option.",
    date: "8 Mars 2026",
    readTime: "7 min",
    author: "Performance Transmission",
  },
];

const Blog = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
            data-testid="back-to-home-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>
      
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 font-['Manrope']">
          Blog
        </h1>
        <p className="text-lg text-gray-600 mb-12">
          Conseils et actualités en comptabilité, fiscalité et gestion d'entreprise en Suisse.
        </p>
        
        {/* Blog Posts List */}
        <div className="space-y-8">
          {blogPosts.map((post) => (
            <article 
              key={post.id}
              className="group border border-gray-200 rounded-xl p-6 hover:border-blue-600 transition-colors"
            >
              <Link to={`/blog/${post.slug}`} className="block">
                <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    {post.readTime} de lecture
                  </span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-3 font-['Manrope'] group-hover:text-blue-600 transition-colors">
                  {post.title}
                </h2>
                <p className="text-gray-600 mb-4">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center gap-2 text-blue-600 font-medium text-sm group-hover:gap-3 transition-all">
                  Lire l'article
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            </article>
          ))}
        </div>
      </main>
      
      <footer className="border-t border-gray-200 py-8">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
          © 2025 Performance Transmission Sàrl. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
};

export default Blog;
